import React from "react";
import PropTypes from "prop-types";

export default function InfoIconSVG(props) {
  const {
    styles: {
      height,
      width,
      fill
    }
  } = props;
  return (
    <svg
      id={props.id || ''}
      className={props.className || ''}
      height={height || "32px"}
      width={width || "32px"}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <g id="Icon/Mini/Check">
        <g id="Icon/Action/Check" fill={fill || "#1475c4"} >
          <path d="M20.6666667,12 L20.6666667,29.5 L23,29.5 L23,32 L9,32 L9,29.5 L15.4166667,29.5 L11.3333333,27 L11.3333333,14.5 L9,14.5 L9,12 L20.6666667,12 Z M15.5,0 C17.9807692,0 20,2.01923077 20,4.5 C20,6.98076923 17.9807692,9 15.5,9 C13.0192308,9 11,6.98076923 11,4.5 C11,2.01923077 13.0192308,0 15.5,0 Z" id="path-1"></path>
        </g>
      </g>
    </svg>
  );
}

InfoIconSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};

InfoIconSVG.defaultProps = {
  styles: {
    fill: "#1475c4",
    height: "32px",
    width: "32px"
  }
};
